import styles from './styles.module.scss';

const TabPanel = ({ children, className, ...restProps }) => {
  return (
    <div
      className={`${styles.panel} ${className}`}
      {...restProps}
      itemScope
      itemType='https://schema.org/Property'
    >
      {children}
    </div>
  );
};

export default TabPanel;
